import React, { Component } from "react";
import NewsList_BannerTitle from "../../../layouts/news/NewsList_BannerTitle";
import NewsList_SideBar from "../../../layouts/_admin/news/NewsList_SideBar";
import NewsList_Content from "../../../layouts/_admin/news/NewsList_Content";
import {
  Header,
  Footer,
  TopBar,
  BottomBar,
} from "../../../layouts/_admin/general/index";
import { firestore } from "src/helpers/Firebase";
import { TimestampToDate } from "src/helpers/functions";

class Admin_NewsList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      headers: [
        {
          id: 1,
          logoweb: "assets/img/logo-small.png",
          names: "Novosti",
        },
      ],
      banners: [
        {
          id: 1,
          links: "",
          titlelink: "",
          border: "",
          name: "Novosti",
          heading: "Novosti",
        },
      ],
    };
  }

  componentDidMount() {
    this.loadNews();
  }

  async loadNews() {
    firestore
      .collection("Web/Corporate/DataBase/News/DataBase")
      .orderBy("releaseDate", "desc")
      .get()
      .then((querySnapshot) => {
        const newsList = [];

        querySnapshot.forEach((doc) => {
          const data = doc.data();
          newsList.push({
            ...data,
            id: doc.id,
            srcimg: data.headerImage,
            aritcles: "hentry data-effect",
            classnames:
              "post-media data-effect-item has-effect-icon offset-v-25 offset-h-24clerafix",
            title: data.title,
            date: TimestampToDate(data.releaseDate),
            day: new Date(data.releaseDate * 1000).getDate(),
            month: TimestampToDate(data.releaseDate, {
              month: "short",
            }),
            author: data.author,
            comments: "3",
            shortContent: data.shortContent,
          });
        });

        this.setState({ newsList, loading: false });
      });
  }

  render() {
    const { newsList, loading } = this.state;

    return (
      <div className="header-fixed sidebar-right header-style-2 topbar-style-1 menu-has-search">
        <div id="wrapper" className="animsition">
          <div id="page" className="clearfix">
            <div id="site-header-wrap">
              <TopBar />
              {this.state.headers.map((data, idx) => (
                <Header data={data} key={idx} />
              ))}
            </div>
            {this.state.banners.map((data) => (
              <NewsList_BannerTitle key={data.id} data={data} />
            ))}
            <div id="main-content" className="site-main clearfix">
              <div id="content-wrap" className="container">
                <div
                  className="themesflat-spacer clearfix"
                  data-desktop={60}
                  data-mobile={60}
                  data-smobile={60}
                />

                {loading ? (
                  <div className="loading" />
                ) : (
                  <NewsList_Content newsList={newsList} />
                )}

                <NewsList_SideBar newsList={newsList.split(0, 3)} />
                <div
                  className="themesflat-spacer clearfix"
                  data-desktop={80}
                  data-mobile={60}
                  data-smobile={60}
                />
              </div>
            </div>
            {this.state.headers.map((data, idx) => (
              <BottomBar data={data} key={idx} />
            ))}
          </div>
        </div>
      </div>
    );
  }
}

export default Admin_NewsList;
